import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'

/**
 * Cuántas decisiones esperan en cada módulo.
 *
 * Alimenta los contadores naranjas del menú. Es la única cifra que el sistema
 * pone delante de la gente sin que la pidan, porque es la única que significa
 * «hay trabajo detenido esperándote a ti».
 */
export function usePendientesDeDecision(): Record<string, number> {
  const consulta = useQuery({
    queryKey: ['pendientes-de-decision'],
    // Se refresca solo cada minuto: es un contador de contexto, no un dato que
    // se esté mirando fijamente.
    refetchInterval: 60_000,
    queryFn: async (): Promise<Record<string, number>> => {
      const [enCompuerta, sinPrecio] = await Promise.all([
        // Compuerta 1: cotizaciones esperando la decisión de Gerencia.
        supabase
          .from('cotizaciones')
          .select('id', { count: 'exact', head: true })
          .eq('estado', 'cotizada'),
        // Órdenes que ya están contadas pero todavía no valen nada.
        supabase
          .from('ordenes_servicio')
          .select('id', { count: 'exact', head: true })
          .eq('estado', 'pendiente_cotizar'),
      ])

      return {
        '/ordenes': (enCompuerta.count ?? 0) + (sinPrecio.count ?? 0),
        '/cotizaciones': enCompuerta.count ?? 0,
      }
    },
  })

  return consulta.data ?? {}
}
